export default __webpack_public_path__ + "static/media/Screenshot (109).d333a770.png";